import React from 'react';
import { styled } from '@mui/system';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useTranslate } from 'hooks/useTranslate';

const ChosenFiltersWrapper = styled('div')(({ theme }) => ({
  marginBottom: 40,
  [theme.breakpoints.down('md')]: {
    marginBottom: 20
  }
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gap: 4
  }
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    height: 26
  },
  '& span': {
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      lineHeight: '10px',
      paddingLeft: 9,
      paddingRight: 9
    }
  }
}));

const ChosenFilters = ({ filters, actions }) => {
  const t = useTranslate('Consultants');

  const handleDeleteFilter = React.useCallback(
    (id) => {
      actions.clearData();

      const body = { ...filters };

      delete body[id];

      actions.onFilterChange(body);
    },
    [actions, filters]
  );

  const list = React.useMemo(() => Object.keys(filters).filter(Boolean), [filters]);

  if (!list.length) {
    return null;
  }

  return (
    <ChosenFiltersWrapper>
      <StyledStack direction="row">
        {list.map((key) => {
          const value = filters[key];

          if (!value) {
            return null;
          }

          let label = `${t(key)}: ${value}`;

          if (['price_min', 'price_max'].includes(key)) {
            label = `${label} ${t('Currency')}`;
          }

          if (typeof value === 'boolean') {
            label = t(key);
          }

          return <StyledChip key={key} label={label} onDelete={() => handleDeleteFilter(key)} />;
        })}
      </StyledStack>
    </ChosenFiltersWrapper>
  );
};

export default ChosenFilters;
